
import image0 from "gallery-image:ua-2021-11-17:L1000497-bw";
import image1 from "gallery-image:ua-2021-11-17:L1000475-bw";
import image2 from "gallery-image:ua-2021-11-17:L1000394-bw";
import image3 from "gallery-image:ua-2021-11-17:L1000506-bw";
import image4 from "gallery-image:ua-2021-11-17:L1000471-bw";
import image5 from "gallery-image:ua-2021-11-17:L1000424-bw";
import image6 from "gallery-image:ua-2021-11-17:L1000405-color";
import image7 from "gallery-image:ua-2021-11-17:L1000416-bw";

const images = { 'L1000497-bw': image0,
'L1000475-bw': image1,
'L1000394-bw': image2,
'L1000506-bw': image3,
'L1000471-bw': image4,
'L1000424-bw': image5,
'L1000405-color': image6,
'L1000416-bw': image7,
 };
export default {
  ...{"id":"ua-2021-11-17","title":"urban artworks"},
  tiles: [ {
  color: "blue",
  size: "small",
  position: "left",
  lift: false,
  image: images["L1000497-bw"]
}, 
{
  color: "blue",
  size: "large",
  position: "right",
  lift: false,
  image: images["L1000475-bw"]
}, 
{
  color: "blue",
  size: "x-large",
  position: "far-left",
  lift: false,
  image: images["L1000394-bw"]
}, 
{
  color: "blue",
  size: "small",
  position: "right",
  lift: false,
  image: images["L1000506-bw"]
}, 
{
  color: "blue",
  size: "small",
  position: "left",
  lift: false,
  image: images["L1000471-bw"]
}, 
{
  color: "blue",
  size: "large",
  position: "right",
  lift: false,
  image: images["L1000424-bw"]
}, 
{
  color: "blue",
  size: "small",
  position: "far-right",
  lift: true,
  image: images["L1000405-color"]
}, 
{
  color: "blue",
  size: "small",
  position: "left",
  lift: true,
  image: images["L1000416-bw"]
} ]
};
